import type { ComponentProps, ReactNode } from 'react'
import { Link } from 'react-router'
import { useLanguage } from '#src/hooks/useLanguage.js'
import { languageService } from '#src/languageService.js'

type Props = Omit<ComponentProps<typeof Link>, 'to'> & {
  href: string
  /** Next-style: scroll={false} keeps the scroll position on navigation. */
  scroll?: boolean
}

/**
 * `Link` that rewrites an internal canonical href to the active language,
 * e.g. `/contact` -> `/sv/contact` on Swedish pages. External links
 * (`mailto:`/`tel:`/`http(s)`/`#`) are passed through unchanged.
 *
 * Use for CMS-driven internal links; `NavLink` already does this for site nav.
 */
export function LocalizedLink(props: Props): ReactNode {
  const { href, scroll, ...rest } = props
  const lang = useLanguage()
  return (
    <Link
      {...rest}
      to={languageService.localizePath(href, lang)}
      preventScrollReset={scroll === false}
    />
  )
}
